export const WIDGET_FILTER_IDS = {
  MEETING_ROOM_ATTENDEES: 'meeting-room-attendees',
  MEETING_ROOM_DATES: 'meeting-room-dates',
  GUEST_ROOM_ATTENDEES: 'guest-room-attendees',
  GUEST_ROOM_DATES: 'guest-room-dates'
};
export const WIDGET_BUTTON_STATES = {
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  AVAILABLE: 'AVAILABLE',
  DEFAULT: 'DEFAULT'
};

export const BOOKABLE_ENTITY = {
  MEETING_ROOM: 'MEETING_ROOM',
  GUEST_ROOM: 'GUEST_ROOM',
  BOTH: 'BOTH',
  NONE: 'NONE'
};

export const WIDGET_MESSAGE_STATES = {
  NO_MESSAGE: 'NO_MESSAGE',
  INVENTORY_AVAILABLE: 'INVENTORY_AVAILABLE',
  MEETING_ROOMS_ONLY: 'MEETING_ROOMS_ONLY',
  GUEST_ROOMS_ONLY: 'GUEST_ROOMS_ONLY',
  INVENTORY_NOT_AVAILABLE: 'INVENTORY_NOT_AVAILABLE'
};
